import * as Yup from "yup";

const DELETE_ACCOUNT_SCHEMA = Yup.object({
  country_code: Yup.string().trim().required("Required"),
  reason: Yup.string().trim().required("Required"),
});

export default DELETE_ACCOUNT_SCHEMA;

